export default {
      id: "siteSatellite-usage",
      viewBox: "0 0 16 21",
      url: __webpack_public_path__ + "icons.svg#siteSatellite",
      toString: function () {
        return this.url;
      }
    }